import { render, staticRenderFns } from "./contest-quiz-section-config-update.html?vue&type=template&id=7823fa86&scoped=true&"
import script from "./contest-quiz-section-config-update.js?vue&type=script&lang=js&"
export * from "./contest-quiz-section-config-update.js?vue&type=script&lang=js&"
import style0 from "./contest-quiz-section-config-update.scss?vue&type=style&index=0&id=7823fa86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823fa86",
  null
  
)

export default component.exports